import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewSubtractIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewSubtract" ref={ref} {...props}>
      <path d="M19,6.51h-.46V6.05A3.76,3.76,0,0,0,14.79,2.3H5A3.76,3.76,0,0,0,1.25,6.05v7.69A3.76,3.76,0,0,0,5,17.49h.46V18A3.76,3.76,0,0,0,9.21,21.7H19A3.76,3.76,0,0,0,22.75,18V10.26A3.76,3.76,0,0,0,19,6.51Zm-2,7.23A2.25,2.25,0,0,1,14.79,16H5a2.25,2.25,0,0,1-2.25-2.25V6.05A2.25,2.25,0,0,1,5,3.8h9.79A2.25,2.25,0,0,1,17,6.05Z" />
    </Icon>
  ),
) as IconWithRender;

ViewSubtractIcon.displayName = 'ViewSubtractIcon';
ViewSubtractIcon.renderIcon = (props) => <ViewSubtractIcon {...props} />;
export default ViewSubtractIcon;
